import * as Actions from 'actions/parking-monitoring/positions';
import { ParkingAnomalyByPositionId, PositionsParkingAnomaly } from 'models/parking-monitoring';

export interface State {
  data: PositionsParkingAnomaly[];
  byPositionId?: ParkingAnomalyByPositionId;
  isFetching: boolean;
}

export const initState: State = {
  data: [],
  byPositionId: {},
  isFetching: false,
};

export const reducer = (state: State = initState, action: Actions.Action): State => {
  switch (action.type) {
    case Actions.GET_POSITIONS_PARKING_ANOMALY_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    case Actions.GET_BY_POSITION_ID_PARKING_ANOMALY:
      return {
        ...state,
        isFetching: true,
      };
    case Actions.GET_BY_POSITION_ID_PARKING_ANOMALY_SUCCESS:
      const { occupy_max_interval, availability_max_interval } = action.payload;
      return {
        ...state,
        byPositionId: {
          ...action.payload,
          occupy_max_interval: occupy_max_interval ? Math.trunc( occupy_max_interval / 3600) : undefined,
          availability_max_interval: availability_max_interval ? Math.trunc( availability_max_interval / 3600) : undefined
        },
        isFetching: false,
      };
    case Actions.GET_BY_POSITION_ID_PARKING_ANOMALY_FAILED:
      return {
        ...state,
        byPositionId: undefined,
        isFetching: false
      };
    default:
      return state;
  }
};
